import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import DetailItem from '../DetailItem/DetailItem';
import { ApaStatus } from '../../../../types/graphql-global-types';
import { IUserEditState } from '../utils';
import CustomAccordion from '../../../../common/components/CustomAccordion/CustomAccordion';

interface Params {
  userState: IUserEditState;
  setUserState: React.Dispatch<React.SetStateAction<IUserEditState>>;
  canEditUser: boolean;
}

const APA_STATUSES: { [p: string]: string } = {
  [ApaStatus.INDEPENDANT]: 'Indépendant',
  [ApaStatus.SALARIE]: 'Salarié',
};

const UserRegimeAndId: FC<Params> = (props) => {
  const { userState, setUserState, canEditUser } = props;

  return (
    <CustomAccordion title="Régime">
      <Grid container>
        <DetailItem<IUserEditState>
          select
          mutationVariableName="apaStatus"
          name="Régime"
          value={userState.apaStatus}
          options={Object.keys(APA_STATUSES)}
          labelAccessor={(status) => APA_STATUSES[status]}
          editable={canEditUser}
          setUserState={setUserState}
        />
        {userState.apaStatus === ApaStatus.INDEPENDANT && (
          <DetailItem<IUserEditState>
            mutationVariableName="siren"
            name="Nᵒ SIREN"
            value={userState.siren}
            editable={canEditUser}
            setUserState={setUserState}
          />
        )}
        {userState.apaStatus === ApaStatus.INDEPENDANT && (
          <DetailItem<IUserEditState>
            mutationVariableName="iban"
            name="IBAN"
            value={userState.iban}
            editable={canEditUser}
            setUserState={setUserState}
          />
        )}
        {userState.apaStatus === ApaStatus.SALARIE && (
          <DetailItem<IUserEditState>
            mutationVariableName="secu"
            name="Nᵒ SECU"
            value={userState.secu}
            editable={canEditUser}
            setUserState={setUserState}
          />
        )}
      </Grid>
    </CustomAccordion>
  );
};

export default UserRegimeAndId;
